<template>
	<UiModalMobile
		v-model="modelValue"
		class="cargo-issue-modal"
		:is-need-btn-save="false"
		:is-need-cancel-btn="false"
		height="calc(100% - 32px)"
		min-height-body="unset"
		custom-padding="20px 16px"
	>
		<div class="cargo-issue-modal__content">
			<div class="cargo-issue-modal__header">
				<TypographyKTypographyBody2
					color="#e32f3e"
					font-type="bold"
				>
					Груз #{{ cargoNumber }}
				</TypographyKTypographyBody2>
				<span
					v-if="selectedCargoDetails?.deliveryToClient || selectedCargoDetails?.deliveryFromTruck"
					class="cargo-details__delivery"
					:class="{
						'cargo-details__delivery--pickup':
							!selectedCargoDetails?.deliveryToClient && selectedCargoDetails?.deliveryFromTruck
					}"
				>
					{{ selectedCargoDetails?.deliveryToClient ? 'Доставка с фуры' : 'Выдача с фуры' }}
				</span>
				<!-- <div class="cargo-issue-modal__status">
					<Icon
						name="ix:certificate-exclamation-filled"
						:color="selectedCargoDetails?.paymentStatusBgColor"
						size="23px"
					/>
					<span :style="{ color: selectedCargoDetails?.paymentStatusBgColor }">
						{{ selectedCargoDetails?.paymentStatusName }}
					</span>
				</div> -->
			</div>
			<CommonStatusCargoPaymentStatus
				:amount="selectedCargoDetails?.summaryCost ?? null"
				:payment-status-bg-color="selectedCargoDetails?.paymentStatusBgColor || '#DC2626'"
				:payment-status-name="selectedCargoDetails?.paymentStatusName || ''"
				:isPaid="selectedCargoDetails?.isPaid"
			/>

			<div class="cargo-issue-modal__payment">
				<UiInput
					id="cargo-issue-payment"
					v-model="paymentAmount"
					:isNumberOnlyAllowDots="true"
					:numberOnly="true"
					:min="0"
					step="any"
					:label="`Сумма, оплаченная при выдаче (${currencySymbol})`"
					placeholder="0.00"
				/>
			</div>

			<section class="cargo-issue-modal__info">
				<button
					type="button"
					class="cargo-issue-modal__info-toggle"
					:aria-expanded="isInfoExpanded"
					@click="isInfoExpanded = !isInfoExpanded"
				>
					<div class="info">
						<Icon
							name="fluent:info-20-filled"
							color="#006EA9"
							size="24px"
						/>
						<span :style="{ color: '#006EA9' }"> Информация </span>
					</div>
					<span class="cargo-issue-modal__expand-label">
						<div class="btn_togle">
							{{ isInfoExpanded ? 'свернуть' : 'развернуть' }}
						</div>

						<Icon
							name="material-symbols:keyboard-arrow-down-rounded"
							color="#2e4a85"
							:class="{ 'cargo-issue-modal__arrow--expanded': isInfoExpanded }"
						/>
					</span>
				</button>
				<p v-if="isInfoExpanded">
					Груз может быть выдан без оплаты, документы и фотографии выдачи можно добавить перед подтверждением.
				</p>
				<p
					v-else
					class="cargo-issue-modal__info-preview"
				>
					Груз может быть выдан без оплаты, документы и фотографии выдачи можно добавить...
				</p>
			</section>

			<section class="cargo-issue-modal__photos">
				<div class="cargo-issue-modal__photos-title">Фото с выдачи</div>
				<div
					v-if="serverPhotos.length || photos.length"
					class="cargo-issue-modal__photo-list"
				>
					<div
						v-for="(image, index) in serverPhotos"
						:key="image.id"
						class="cargo-issue-modal__photo"
					>
						<UiImage
							lazy="lazy"
							:src="image.urlPreview || image.urlOriginal"
							:alt="`Фото выдачи ${index + 1}`"
							@click.stop="openImageModal(index)"
						/>
						<UiButtonIcon
							background="var(--white)"
							padding="4px"
							class="btn_remove"
							:aria-label="`Удалить фото ${index + 1}`"
							@click="removeServerPhoto(image)"
						>
							<UiIcon
								name="remove"
								folder="button"
								width="19px"
								height="19px"
							/>
						</UiButtonIcon>
					</div>
					<div
						v-for="(photo, index) in photos"
						:key="photo.blobUrl"
						class="cargo-issue-modal__photo"
					>
						<UiImage
							lazy="lazy"
							:src="photo.blobUrl"
							:alt="`Фото выдачи ${index + 1}`"
							@click.stop="openImageModal(serverPhotos.length + index)"
						/>
						<UiButtonIcon
							background="var(--white)"
							padding="4px"
							class="btn_remove"
							:aria-label="`Удалить фото ${index + 1}`"
							:disabled="photo.uploadStatus === 'uploading'"
							@click="removePhoto(index)"
						>
							<UiIcon
								name="remove"
								folder="button"
								width="19px"
								height="19px"
							/>
						</UiButtonIcon>
						<div
							v-if="photo.uploadStatus === 'uploading'"
							class="cargo-issue-modal__photo-status"
						>
							<UiLoader
								:radius="14"
								:circle-width="2"
								:color="'var(--primary)'"
							/>
						</div>
						<div
							v-else-if="photo.uploadStatus === 'queued'"
							class="cargo-issue-modal__photo-status cargo-issue-modal__photo-status--queued"
						>
							Ожидает сети
						</div>
						<button
							v-else-if="photo.uploadStatus === 'failed'"
							type="button"
							class="cargo-issue-modal__photo-status cargo-issue-modal__photo-status--failed"
							@click="retryPhotoUpload(photo)"
						>
							Повторить
						</button>
					</div>
				</div>
				<UiButtonFile
					:color="ButtonType.outline"
					:size="ButtonSizeType.small"
					:label="'Добавить фото'"
					:isMultiple="true"
					:width="'100%'"
					@load="addPhotos"
				>
					<UiIcon
						name="camera"
						folder="cargos"
						width="18px"
						height="18px"
						color="var(--btn-primary)"
					/>
				</UiButtonFile>
			</section>
		</div>
		<template #custom-actions>
			<div class="cargo-issue-modal__actions">
				<UiButton
					:color="ButtonType.outline"
					:size="ButtonSizeType.big"
					@click="emits('cancel')"
				>
					Отмена
				</UiButton>
				<UiButton
					:color="ButtonType.green"
					:size="ButtonSizeType.big"
					:is-loading="isSubmitting"
					@click="isConfirmIssueOpen = true"
				>
					Выдать груз
				</UiButton>
			</div>
		</template>
	</UiModalMobile>
	<UiModalConfirm
		v-if="isConfirmIssueOpen"
		v-model="isConfirmIssueOpen"
		title="Выдать груз?"
		subtitle="После подтверждения груз будет отмечен как “Выданный”"
		:is-need-save-btn="true"
		:is-loading="isSubmitting"
		btn-confirm-title="Выдать"
		@save="submitIssue"
	/>
	<UiModalImagesModal
		v-if="isImageModalOpen"
		v-model="isImageModalOpen"
		:initial-index="initialImageIndex"
		:images="imageModalImages"
	/>
</template>

<script setup lang="ts">
	import { useCargoImageStore } from '~/store/cargoImage.store';
	import { getOfflineRequests, removeOfflineRequest } from '~/helpers/offlineRequestQueue';
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';
	import type { ICargoImage } from '~~/shared/interfaces/driverRequests';
	import { useNotificationStore } from '~/store/notification.store';
	import type { ICargoInTripDetails } from '~~/shared/interfaces/truck';

	interface ILocalPhoto {
		file: File;
		blobUrl: string;
		uploadStatus: 'uploading' | 'uploaded' | 'queued' | 'failed';
		offlineRequestId?: number;
		imageId?: string;
		previousImageIds?: string[];
	}

	const props = defineProps<{
		cargoId: string;
		cargoNumber: string;
		currencyTicker: string;
		selectedCargoDetails: ICargoInTripDetails;
		isSubmitting?: boolean;
	}>();

	const emits = defineEmits<{
		cancel: [];
		issue: [payload: { paymentAmount: number | null }];
	}>();
	const modelValue = defineModel<boolean>({ required: true });
	const cargoImageStore = useCargoImageStore();
	const notificationStore = useNotificationStore();
	const paymentAmount = ref('');
	const isInfoExpanded = ref(false);
	const isConfirmIssueOpen = ref(false);
	const photos = ref<ILocalPhoto[]>([]);
	const serverPhotos = ref<ICargoImage[]>([]);
	const isImageModalOpen = ref(false);
	const initialImageIndex = ref<number | null>(null);
	const imageModalImages = computed(() => [
		...serverPhotos.value.map((image) => ({ preview: image.urlPreview, url: image.urlOriginal })),
		...photos.value.map((photo) => ({ preview: photo.blobUrl, url: photo.blobUrl }))
	]);

	const currencySymbol = computed(() => {
		switch (props.currencyTicker) {
			case 'KZT':
				return '₸';
			case 'RUB':
				return '₽';
			case 'USD':
				return '$';
			case 'EUR':
				return '€';
			default:
				return props.currencyTicker || '—';
		}
	});

	const openImageModal = (index: number) => {
		initialImageIndex.value = index;
		setTimeout(() => {
			isImageModalOpen.value = true;
		});
	};

	const refreshServerPhotos = async () => {
		const response = await cargoImageStore.getCargoImagesByCargo({
			cargoId: props.cargoId,
			cargoImageType: 'Delivery'
		});
		if (response.status !== 'success') return null;
		serverPhotos.value = response.data ?? [];
		return serverPhotos.value;
	};

	const resolveUploadedImage = async (photo: ILocalPhoto) => {
		if (!photo.previousImageIds) return null;
		const images = await refreshServerPhotos();
		if (!images) return null;
		const previousIds = new Set(photo.previousImageIds);
		return images.find((image) => !previousIds.has(image.id)) ?? null;
	};

	const removePhotoPreview = (photo: ILocalPhoto) => {
		const photoIndex = photos.value.indexOf(photo);
		if (photoIndex !== -1) photos.value.splice(photoIndex, 1);
		URL.revokeObjectURL(photo.blobUrl);
	};

	const uploadPhoto = async (photo: ILocalPhoto) => {
		photo.uploadStatus = 'uploading';
		try {
			photo.previousImageIds = serverPhotos.value.map((image) => image.id);

			const response = await cargoImageStore.uploadCargoImage({
				cargoId: props.cargoId,
				files: [photo.file],
				cargoImageType: 'Delivery'
			});

			if (response.status === 'pending' && response.offlineRequestId !== undefined) {
				photo.offlineRequestId = response.offlineRequestId;
				photo.uploadStatus = 'queued';
				return;
			}

			if (response.status !== 'success') {
				photo.uploadStatus = 'failed';
				return;
			}

			try {
				await refreshServerPhotos();
			} catch (error) {
				console.error('Failed to refresh delivery photos after upload:', error);
			} finally {
				removePhotoPreview(photo);
			}
		} catch (error) {
			photo.uploadStatus = 'failed';
			console.error('Failed to upload delivery photo:', error);
		}
	};

	const addPhotos = async (files: ILocalPhoto[]) => {
		if (!Array.isArray(files)) return;

		for (const file of files) {
			const photo: ILocalPhoto = { ...file, uploadStatus: 'uploading' };
			photos.value.push(photo);
			await uploadPhoto(photo);
		}
	};

	const removePhoto = async (index: number) => {
		const photo = photos.value[index];
		if (!photo || photo.uploadStatus === 'uploading') return;

		if (photo.offlineRequestId !== undefined) {
			const queuedRequests = await getOfflineRequests();
			const isStillQueued = queuedRequests.some((request) => request.id === photo.offlineRequestId);
			if (isStillQueued) {
				await removeOfflineRequest(photo.offlineRequestId);
			} else {
				photo.imageId ||= (await resolveUploadedImage(photo))?.id;
			}
		}

		if (!photo.imageId && photo.uploadStatus === 'uploaded') {
			photo.imageId = (await resolveUploadedImage(photo))?.id;
		}

		if (photo.imageId) {
			const response = await cargoImageStore.cargoImageDelete({ id: photo.imageId });
			if (response.status !== 'success' && response.status !== 'pending') return;
			serverPhotos.value = serverPhotos.value.filter((image) => image.id !== photo.imageId);
		} else if (photo.uploadStatus === 'uploaded') {
			notificationStore.addNewAlert('Не удалось определить загруженное фото для удаления.');
			return;
		}

		photos.value.splice(index, 1);
		URL.revokeObjectURL(photo.blobUrl);
	};

	const removeServerPhoto = async (image: ICargoImage) => {
		const response = await cargoImageStore.cargoImageDelete({ id: image.id });
		if (response.status !== 'success' && response.status !== 'pending') return;
		serverPhotos.value = serverPhotos.value.filter((serverPhoto) => serverPhoto.id !== image.id);
	};

	const retryPhotoUpload = (photo: ILocalPhoto) => {
		photo.previousImageIds = undefined;
		void uploadPhoto(photo);
	};

	const onQueuedCargoImageUploaded = (event: Event) => {
		const { detail } = event as CustomEvent<{
			cargoId: string;
			cargoImageType: string;
			offlineRequestId: number;
		}>;
		if (detail.cargoId !== props.cargoId || detail.cargoImageType !== 'Delivery' || !modelValue.value) {
			return;
		}

		const photo = photos.value.find((item) => item.offlineRequestId === detail.offlineRequestId);
		if (!photo) return;

		photo.uploadStatus = 'uploading';
		void resolveUploadedImage(photo)
			.then((image) => {
				if (image) {
					removePhotoPreview(photo);
					return;
				}
				photo.uploadStatus = 'uploaded';
			})
			.catch((error) => {
				photo.uploadStatus = 'uploaded';
				console.error('Failed to refresh delivery photos after queued upload:', error);
			});
	};

	const submitIssue = () => {
		if (photos.value.some((photo) => photo.uploadStatus === 'uploading' || photo.uploadStatus === 'failed')) {
			notificationStore.addNewAlert('Дождитесь загрузки фотографий или повторите неудачную загрузку.');
			return;
		}

		isConfirmIssueOpen.value = false;
		emits('issue', {
			paymentAmount: paymentAmount.value ? Number(paymentAmount.value) : null
		});
	};

	onBeforeUnmount(() => {
		window.removeEventListener('cargo-image-uploaded', onQueuedCargoImageUploaded);
		photos.value.forEach((photo) => URL.revokeObjectURL(photo.blobUrl));
	});

	onMounted(() => {
		window.addEventListener('cargo-image-uploaded', onQueuedCargoImageUploaded);
	});

	watch(
		[modelValue, () => props.cargoId],
		async ([isOpen]) => {
			if (!isOpen) return;
			try {
				await refreshServerPhotos();
			} catch (error) {
				console.error('Failed to load delivery photos:', error);
			}
		},
		{ immediate: true }
	);
</script>

<style scoped lang="scss">
	.cargo-details {
		display: flex;
		flex-direction: column;
		gap: 8px;
		padding: 8px 0 12px;
		color: #303733;
		font-size: 12px;

		&__header {
			display: flex;
			align-items: center;
			gap: 6px;
		}

		&__title {
			display: flex;
			min-width: 0;
			flex-wrap: wrap;
			align-items: center;
			gap: 6px;
		}

		&__delivery {
			display: inline-flex;
			align-items: center;
			gap: 4px;
			border-radius: 14px;
			padding: 3px 4px;
			color: #000000;
			font-size: 10px;
			white-space: nowrap;
			background-color: #d8f2ef;

			&::before {
				width: 11px;
				height: 11px;
				border-radius: 50%;
				background-color: #3cb3ad;
				content: '';
			}

			&--pickup {
				background-color: #dceaff;

				&::before {
					background-color: #4180ff;
				}
			}
		}
	}
	.cargo-issue-modal__content {
		display: flex;
		min-height: 100%;
		flex-direction: column;
		gap: 10px;
		padding: 8px 0 12px;
		color: #303733;
	}

	.cargo-issue-modal__header,
	.cargo-issue-modal__status,
	.cargo-issue-modal__info-toggle,
	.cargo-issue-modal__info-toggle > span,
	.cargo-issue-modal__expand-label {
		display: flex;
		align-items: center;
	}

	.cargo-issue-modal__header {
		gap: 8px;
	}

	.cargo-issue-modal__status {
		display: flex;
		flex-direction: column;
		gap: 2px;
		font-size: 10px;
		margin-left: auto;

		&--paid {
			color: #16b99d;
		}
	}

	.cargo-issue-modal__payment {
		display: flex;
		flex-direction: column;
		gap: 6px;
		font-size: 12px;

		label {
			font-weight: 600;
		}
	}

	.cargo-issue-modal__input-wrapper {
		display: flex;
		align-items: center;
		border: 1px solid #e0e5ef;
		border-radius: 12px;
		padding: 5px 10px;
		background-color: var(--white);

		input {
			width: 100%;
			min-width: 0;
			border: 0;
			outline: 0;
			padding: 5px 0;
			color: #303733;
			font-size: 14px;
			background: transparent;
		}

		button {
			display: flex;
			border: 0;
			padding: 2px;
			background: transparent;
		}
	}

	.cargo-issue-modal__info,
	.cargo-issue-modal__photos {
		border-radius: 12px;
		padding: 10px;
		background-color: #e9ecf4;
	}

	.cargo-issue-modal__info-toggle {
		width: 100%;
		justify-content: space-between;
		gap: 8px;
		border: 0;
		padding: 0;
		font-size: 14px;
		background: transparent;

		.info {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		> span,
		.cargo-issue-modal__expand-label {
			gap: 0px;
		}
	}

	.cargo-issue-modal__expand-label {
		color: #2e4a85;
		font-size: 13px;
		white-space: nowrap;

		.btn_togle {
			text-decoration: underline dotted;
		}
	}

	.cargo-issue-modal__arrow--expanded {
		transform: rotate(180deg);
	}

	.cargo-issue-modal__info p {
		margin: 8px 0 0;
		border-radius: 8px;
		padding: 8px;
		color: #6c7180;
		font-size: 11px;
		line-height: 1.4;
		background-color: var(--white);
	}

	.cargo-issue-modal__info .cargo-issue-modal__info-preview {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.cargo-issue-modal__photos {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.cargo-issue-modal__photos-title {
		font-size: 12px;
		font-weight: 600;
	}

	.cargo-issue-modal__photo-list {
		display: flex;
		flex-wrap: wrap;
		gap: 15px;
		overflow: auto;
		border-radius: 12px;
		padding: 10px 12px;
		background-color: var(--white);
	}

	.cargo-issue-modal__photo {
		position: relative;
		width: 76px;
		height: 76px;
		min-width: 76px;
		margin: 2px 0;
		border-radius: 12px;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		box-shadow: 0 0 5.6px 0 #0000001f;

		:deep(img) {
			width: 76px;
			height: 76px;
			border-radius: 12px;
			object-fit: cover;
		}

		.btn_remove {
			position: absolute;
			top: -9px;
			right: -9px;
			z-index: 1;
		}

		&-status {
			position: absolute;
			inset: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 12px;
			color: var(--primary);
			font-size: 10px;
			font-weight: 600;
			background-color: #ffffffd9;

			&--queued {
				padding: 4px;
				text-align: center;
			}

			&--failed {
				border: 0;
				padding: 4px;
				text-align: center;
				background-color: #ffffffed;
			}
		}
	}

	.cargo-issue-modal__actions {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 10px;
		padding-bottom: env(safe-area-inset-bottom);
	}
</style>
